module.exports = __webpack_public_path__ + "static/media/checkbox-active.893558f5.svg";